export default "__VITE_ASSET__Dpx0DMna__"